/* eslint-disable max-len */
import { get } from "lodash";
import { all, put, select, takeLatest } from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as types from "~/store/fee/feeTypes";
import { REDIRECT_URL_AFTER_PAYMENT_FEE } from "~/utils/constants";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";

const redirectUrl = REDIRECT_URL_AFTER_PAYMENT_FEE;

function* requestSearchFeeCode() {
  try {
    const { hosNumber } = yield select(state => state.fee);
    const partnerId = yield select(state => state.totalData.partnerId);
    // paymentFeeSearchCode
    // paymentFeeSearchCodeV2
    const response = yield client.paymentFeeSearchCodeV2(
      {
        code: hosNumber
      },
      {
        appid: AppId,
        partnerid: partnerId
      }
    );
    yield put({
      type: types.SEARCH_FEE_CODE_SUCCESS,
      payload: response.data
    });
    history.push("/chi-tiet-ma-thanh-toan");
  } catch (error) {
    yield put({
      type: types.SEARCH_FEE_CODE_ERROR
    });
    const message = get(error, "response.data.message");
    openToast(message, "error");
  }
}

function* requestPaymentFee() {
  try {
    const billInfo = yield select(state => state.fee.selectedFee);
    const email = yield select(state => state.fee.email);

    const platformType = get(global, "device.type");

    const paymentMethodReducer = yield select(state => state.payment);
    const methodId = get(paymentMethodReducer, "methodId", "");
    const paymentTypeDetail = get(
      paymentMethodReducer,
      "selectedMethod.code",
      ""
    );

    const postData = {
      id: billInfo.id,
      bill_id: billInfo.bill_id,
      fee_code: billInfo.fee_code,
      platform: platformType === "desktop" ? "pc" : "web",
      methodId,
      paymentTypeDetail,
      redirectUrl,
      email
    };
    const response = yield client.paymentFee(postData, { partnerid: AppId });
    // console.log(response);
    const { data } = response;
    yield put({
      type: types.REQUEST_PAYMENT_FEE_SUCCESS,
      payload: data
    });
    // if (methodId === "qrcode") {
    // Phương thức qrCode
    // const { transactionId, extendData } = data;
    // const obj = {
    //   extendData,
    //   transactionId,
    //   redirectUrl: REDIRECT_URL_AFTER_PAYMENT_FEE,
    //   partnerId: AppId
    // };
    // const params = querystring.stringify(obj);
    // window.location.href = `${currentEnv.PAYMENT_HUB_URL}?${params}`;
    // } else {
    // Các phương thức khác qrCode
    // }
    window.location.href = data.qrCodeUrl;
  } catch (error) {
    console.log(error);
    yield put({
      type: types.REQUEST_PAYMENT_FEE_FAILURE
    });
    const message = get(error, "response.data.message");
    openToast(message, "error");
  }
}

function* requestHistoryPayment() {
  try {
    const token = yield select(state => state.user.info.token);
    const partnerId = yield select(state => state.totalData.partnerId);
    const response = yield client.paymentFeeTracking({
      appid: AppId,
      token: token,
      partnerid: partnerId
    });
    yield put({
      type: types.GET_HISTORY_PAYMENT_SUCCESS,
      payload: response.data
    });
    history.push("/lich-su-thanh-toan-vien-phi");
  } catch (error) {
    const message = get(error, "response.data.message");
    openToast(message, "error");
    yield put({
      type: types.GET_HISTORY_PAYMENT_FAILURE,
      payload: error.response.data
    });
  }
}

export default function* watcher() {
  yield all([
    takeLatest(types.SEARCH_FEE_CODE, requestSearchFeeCode),
    takeLatest(types.REQUEST_PAYMENT_FEE, requestPaymentFee),
    takeLatest(types.GET_HISTORY_PAYMENT, requestHistoryPayment)
  ]);
}
